import { customAlphabet } from "nanoid";

export const matchingData = [
    {
        id: 1,
        name: "None",
        price: 0
    },
    {
        id: 2,
        name: "1 Matching Tefilin Bag (CB-1 9.06\" X 7.87)",
        price: 500
    },
    {
        id: 3,
        name: "Double Matching Tefilin (CB-1 9.06\" X 7.87)",
        price: 1000
    }
]

export const getUniqueId = () => {
    const alphanumeric = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const nanoid = customAlphabet(alphanumeric, 6);
    return nanoid()
}